import { AnyAction, Reducer } from 'redux';
import { HospitalState } from '../models/hospitalModel';
import actionTypes from '../types/hospitalTypes';

const initialState: HospitalState = {
  calendarEvents: [null as any],
  hospitalProfile: null,
  adminSwitchAction: false,
  enableDisableClick: true,
  isLogOutClicked: false,
  hospitalSearchPatientDetails: [],
  selectedPatientDetail: [],
  hisDoctorList: [],
  isLogOutBtnClicked: false,
  isHISCardSelected: false,
  isHISClaim: false,
  hospitalSearchValues: [],
  isUserEmailVerified : false,
  suggestedValuesMap: {},
  HISCardDisplayParameters: [],
  isAutomatedNewAdmission: false,
  HISTreatmentLookUpValues: [],
  isHISPackageFilled: false,
  parsedHISFieldValues: {},
};

const hospitalReducer: Reducer = (
  state: HospitalState = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.HOSPITAL_PROFILE_DATA: return {
      ...state,
      hospitalProfile: action.payload,
    };
    case actionTypes.FETCH_ADMIN_SWITCH: return {
      ...state,
      adminSwitchAction: action.payload,
    };
    case actionTypes.FETCH_ENABLE_DISABLE_CLICK: return {
      ...state,
      enableDisableClick: action.payload,
    };
    case actionTypes.FETCH_CALENDAR_EVENT: return {
      ...state,
      calendarEvents: action.payload,
    };
    case actionTypes.SET_NEW_ENTRY: return {
      ...state,
      newEntry: action.payload,
    };
    case actionTypes.HOSPITAL_LOGO: return {
      ...state,
      hospitalLogo: action.payload,
    };
    case actionTypes.INFRA_IMAGES: return {
      ...state,
      infraImages: action.payload,
    };
    case actionTypes.IP_INCLUSION_MASTER_DATA: return {
      ...state,
      inPatientinclusionMaster: action.payload,
    };
    case actionTypes.IP_DEPARTMENT_MASTER_DATA: return {
      ...state,
      inPatientdepartmentMaster: action.payload,
    };
    case actionTypes.DAYCARE_INCLUSION_MASTER_DATA: return {
      ...state,
      dayCareinclusionMaster: action.payload,
    };
    case actionTypes.DAYCARE_DEPARTMENT_MASTER_DATA: return {
      ...state,
      dayCaredepartmentMaster: action.payload,
    };
    case actionTypes.AMENITY_MASTER_DATA: return {
      ...state,
      amenityMaster: action.payload,
    };
    case actionTypes.IS_LOGOUT_CLICKED: return {
      ...state,
      isLogOutClicked: action.payload,
    };
    case actionTypes.IS_LOGOUT_BTN_CLICKED: return {
      ...state,
      isLogOutBtnClicked: action.payload,
    };
    case actionTypes.SET_PATIENT_LIST:
      return{
        ...state,
        hospitalSearchPatientDetails: action.payload,
      };
    case actionTypes.SET_SELECTED_PATIENT_DATA:
      return{
        ...state,
      selectedPatientDetail: action.payload,
      };
    case actionTypes.SET_HIS_CARD_DISPLAY_PARAMETERS:
      return{
        ...state,
      HISCardDisplayParameters: action.payload,
      };
    case actionTypes.SET_HOSPITAL_SEARCH_VALUES:
      return{
        ...state,
        hospitalSearchValues: action.payload,
      };
    case actionTypes.SET_HIS_DOCTOR_LIST:
      return {
        ...state,
        hisDoctorList : action.payload,
      };
    case actionTypes.SET_HIS_CARD_SELECTED:
      return {
        ...state,
        isHISCardSelected : action.payload,
      };
    case actionTypes.SET_IS_HIS_CLAIM:
      return {
        ...state,
        isHISClaim : action.payload,
      };
    case actionTypes.SET_IS_USER_EMAIL_VERIFIED:
      return {
        ...state,
        isUserEmailVerified : action.payload,
      };
    case actionTypes.SET_SUGGESTED_VALUES_MAP:
      return{
        ...state,
      suggestedValuesMap: action.payload,
      };
    case actionTypes.SET_IS_AUTOMATED_NEW_ADMISSION:
      return {
        ...state,
        isAutomatedNewAdmission: action.payload,
      };
    case actionTypes.SET_PARSED_HIS_VALUES_MAP:
      return {
        ...state,
        parsedHISFieldValues: action.payload,
      };
    case actionTypes.SET_HIS_TREATMENT_DETAILS:
      return {
        ...state,
        HISTreatmentLookUpValues: action.payload,
      };
    case actionTypes.SET_IS_HIS_PACKAGE_FILLED:
      return {
        ...state,
        isHISPackageFilled: action.payload,
      };
    default: return state;
  }
};

export default hospitalReducer;
